import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeeSurveysIndexResponseType,
  ApiManagersEmployeeSurveysIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersEmployeeSurveysIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersEmployeeSurveysIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersEmployeeSurveysIndexResponseType>(
      "/api/managers/employee_surveys",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersEmployeeSurveysIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersEmployeeSurveysIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersEmployeeSurveysIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagerEmployeeSurveysIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
    },
  );
};
